import aaru from 'src/assets/why-we-invest/aaru.png'
import arena from 'src/assets/why-we-invest/arena.png'
import atropos from 'src/assets/why-we-invest/atropos.png'
import cowboy from 'src/assets/why-we-invest/cowboy.png'
import databento from 'src/assets/why-we-invest/databento.png'
import dataland from 'src/assets/why-we-invest/dataland.png'
import dreambig from 'src/assets/why-we-invest/dreambig.png'
import earli from 'src/assets/why-we-invest/earli.png'
import elevenlabs from 'src/assets/why-we-invest/elevenlabs.png'
import elo from 'src/assets/why-we-invest/elo.png'
import finix from 'src/assets/why-we-invest/finix.png'
import groq from 'src/assets/why-we-invest/groq.png'
import hedra from 'src/assets/why-we-invest/hedra.png'
import hone from 'src/assets/why-we-invest/hone.png'
import humansAnd from 'src/assets/why-we-invest/humans-and.png'
import impulse from 'src/assets/why-we-invest/impulse.png'
import invisible from 'src/assets/why-we-invest/invisible.png'
import inworld from 'src/assets/why-we-invest/inworld.png'
import kalshi from 'src/assets/why-we-invest/kalshi.png'
import keycare from 'src/assets/why-we-invest/keycare.png'
import aaruLogo from 'src/assets/why-we-invest/logos/aaru.png'
import arenaLogo from 'src/assets/why-we-invest/logos/arena.png'
import atroposLogo from 'src/assets/why-we-invest/logos/atropos.png'
import cowboyLogo from 'src/assets/why-we-invest/logos/cowboy.png'
import databentoLogo from 'src/assets/why-we-invest/logos/databento.png'
import datalandLogo from 'src/assets/why-we-invest/logos/dataland.png'
import dreambigLogo from 'src/assets/why-we-invest/logos/dreambig.png'
import earliLogo from 'src/assets/why-we-invest/logos/earli.png'
import elevenlabsLogo from 'src/assets/why-we-invest/logos/elevenlabs.png'
import eloLogo from 'src/assets/why-we-invest/logos/elo.png'
import finixLogo from 'src/assets/why-we-invest/logos/finix.png'
import groqLogo from 'src/assets/why-we-invest/logos/groq.png'
import hedraLogo from 'src/assets/why-we-invest/logos/hedra.png'
import honeLogo from 'src/assets/why-we-invest/logos/hone.png'
import humansAndLogo from 'src/assets/why-we-invest/logos/humans-and.png'
import impulseLogo from 'src/assets/why-we-invest/logos/impulse.png'
import invisibleLogo from 'src/assets/why-we-invest/logos/invisible.png'
import inworldLogo from 'src/assets/why-we-invest/logos/inworld.png'
import kalshiLogo from 'src/assets/why-we-invest/logos/kalshi.png'
import keycareLogo from 'src/assets/why-we-invest/logos/keycare.png'
import lumaLogo from 'src/assets/why-we-invest/logos/luma.png'
import mercorLogo from 'src/assets/why-we-invest/logos/mercor.png'
import mistralLogo from 'src/assets/why-we-invest/logos/mistral.png'
import onyxLogo from 'src/assets/why-we-invest/logos/onyx.png'
import openaiLogo from 'src/assets/why-we-invest/logos/openai.png'
import panthalassaLogo from 'src/assets/why-we-invest/logos/panthalassa.png'
import periodicLogo from 'src/assets/why-we-invest/logos/periodic.png'
import physicalIntelligenceLogo from 'src/assets/why-we-invest/logos/physical-intelligence.png'
import poseidonLogo from 'src/assets/why-we-invest/logos/poseidon.png'
import precisionLogo from 'src/assets/why-we-invest/logos/precision.png'
import rangeLogo from 'src/assets/why-we-invest/logos/range.png'
import sequenceLogo from 'src/assets/why-we-invest/logos/sequence.png'
import shieldLogo from 'src/assets/why-we-invest/logos/shield.png'
import temporalLogo from 'src/assets/why-we-invest/logos/temporal.png'
import tenstorrentLogo from 'src/assets/why-we-invest/logos/tenstorrent.png'
import thriveLogo from 'src/assets/why-we-invest/logos/thrive.png'
import udioLogo from 'src/assets/why-we-invest/logos/udio.png'
import xinobiLogo from 'src/assets/why-we-invest/logos/xinobi.png'
import luma from 'src/assets/why-we-invest/luma.png'
import mercor from 'src/assets/why-we-invest/mercor.png'
import mistral from 'src/assets/why-we-invest/mistral.png'
import onyx from 'src/assets/why-we-invest/onyx.png'
import openai from 'src/assets/why-we-invest/openai.png'
import panthalassa from 'src/assets/why-we-invest/panthalassa.png'
import periodic from 'src/assets/why-we-invest/periodic.png'
import physicalIntelligence from 'src/assets/why-we-invest/physical-intelligence.png'
import poseidon from 'src/assets/why-we-invest/poseidon.png'
import precision from 'src/assets/why-we-invest/precision.png'
import range from 'src/assets/why-we-invest/range.png'
import sequence from 'src/assets/why-we-invest/sequence.png'
import shield from 'src/assets/why-we-invest/shield.png'
import temporal from 'src/assets/why-we-invest/temporal.png'
import tenstorrent from 'src/assets/why-we-invest/tenstorrent.png'
import thrive from 'src/assets/why-we-invest/thrive.png'
import udio from 'src/assets/why-we-invest/udio.png'
import xinobi from 'src/assets/why-we-invest/xinobi.png'

import { ICompanyAssets } from '../types'

/**
 * Local image + logo assets keyed by company id/slug. The API supplies all text;
 * images are never sourced from the API. The matching key here is the contract
 * the mapper relies on — keep keys in sync with the API's company identifiers.
 */
export const companyAssets: Record<string, ICompanyAssets> = {
  xinobi: { image: xinobi, logo: xinobiLogo },
  poseidon: { image: poseidon, logo: poseidonLogo },
  onyx: { image: onyx, logo: onyxLogo },
  periodic: { image: periodic, logo: periodicLogo },
  cowboy: { image: cowboy, logo: cowboyLogo },
  inworld: { image: inworld, logo: inworldLogo },
  elo: { image: elo, logo: eloLogo },
  hone: { image: hone, logo: honeLogo },
  dreambig: { image: dreambig, logo: dreambigLogo },
  earli: { image: earli, logo: earliLogo },
  mistral: { image: mistral, logo: mistralLogo },
  udio: { image: udio, logo: udioLogo },
  atropos: { image: atropos, logo: atroposLogo },
  tenstorrent: { image: tenstorrent, logo: tenstorrentLogo },
  groq: { image: groq, logo: groqLogo },
  finix: { image: finix, logo: finixLogo },
  luma: { image: luma, logo: lumaLogo },
  databento: { image: databento, logo: databentoLogo },
  keycare: { image: keycare, logo: keycareLogo },
  precision: { image: precision, logo: precisionLogo },
  range: { image: range, logo: rangeLogo },
  shield: { image: shield, logo: shieldLogo },
  temporal: { image: temporal, logo: temporalLogo },
  sequence: { image: sequence, logo: sequenceLogo },
  hedra: { image: hedra, logo: hedraLogo },
  dataland: { image: dataland, logo: datalandLogo },
  thrive: { image: thrive, logo: thriveLogo },
  invisible: { image: invisible, logo: invisibleLogo },
  'physical-intelligence': {
    image: physicalIntelligence,
    logo: physicalIntelligenceLogo,
  },
  mercor: { image: mercor, logo: mercorLogo },
  kalshi: { image: kalshi, logo: kalshiLogo },
  impulse: { image: impulse, logo: impulseLogo },
  openai: { image: openai, logo: openaiLogo },
  'humans-and': { image: humansAnd, logo: humansAndLogo },
  aaru: { image: aaru, logo: aaruLogo },
  elevenlabs: { image: elevenlabs, logo: elevenlabsLogo },
  arena: { image: arena, logo: arenaLogo },
  panthalassa: { image: panthalassa, logo: panthalassaLogo },
}
